/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';
import { useEffect } from 'react';
import { authService } from 'services/auth/AuthService';

export const RedirectSSO = () => {
  useEffect(() => {
    authService.startAuthentication();
  }, []);

  return <> </>;
};
